import React from 'react';
import {createNativeStackNavigator} from '@react-navigation/native-stack';
import TasksListScreen from '../screens/task/TasksListScreen';
import TaskManagementScreen from '../screens/task/TaskManagementScreen';

const Stack = createNativeStackNavigator();

const TasksNavigator = () => {
  return (
    <Stack.Navigator screenOptions={{headerShown: false}}>
      <Stack.Screen name="TasksList" component={TasksListScreen} />
      <Stack.Screen name="TaskManagement" component={TaskManagementScreen} />
    </Stack.Navigator>
  );
};

export default TasksNavigator;
